const JSCL_MSG_DEFAULT = {
    msg_0: "Parsing error near %1$s symbol\: %2$s",
    msg_1: "Parsing error occurred near %1$s symbol\: check expression validity",
    msg_2: "There is no operator with name\: %1$s",
    msg_3: "Operator name is not valid\: %1$s",
    msg_4: "Postfix function with name %1$s doesn't exist",
    msg_5: "Constant name must start with a character",
    msg_6: "Function or operator with the same name is already defined\: %1$s",
    msg_7: "Digit is expected",
    msg_8: "Invalid number\: %1$s",
    msg_9: "The first letter of the number must be a digit",
    msg_10: "Expected characters are %1$s or %2$s",
    msg_11: "Expected characters are %1$s",
    msg_12: "Expected character is %1$s",
    msg_13: "Function name is not valid\: %1$s",
    msg_14: "Expected number of parameters differs from actual %1$s",
    msg_15: "Only decimal numeral base supports decimal numbers",
    msg_16: "Following errors occurred while calculations\:",
    msg_17: "Unable to convert numeral base of %1$s. Change default numeral base to decimal and try again.",
    msg_18: "Calculation of a triple factorial is not supported\!",
    msg_19: "Custom function with name %1$s could not be calculated due to the following error\: %2$s",
    msg_20: "Function %1$s cannot be integrated for not radian angle units\!",
    msg_21: "Integration is not supported for %1$s",
    msg_22: "Integration is not supported",
    msg_23: "Complex number computation in non-RAD mode can lead to unexpected results\!",
    msg_24: "Integration in non-RAD mode can lead to unexpected results\!",
    msg_25: "Differentiation in non-RAD mode can lead to unexpected results\!",
    osac_msg_5: "No parameters are specified for function\: %1$s",
    osac_msg_6: "Infinite loop is detected in expression",
};
const JSCL_MSG_ZH_CN = {
    msg_0: "在符号 %1$s 处出现解析错误：%2$s",
    msg_1: "在符号 %1$s 处出现解析错误：请检查表达式是否有效",
    msg_2: "不存在名称为 %1$s 的运算符",
    msg_3: "运算符名称 %1$s 无效",
    msg_4: "后缀函数 %1$s 不存在",
    msg_5: "常量名称必须以字母开始",
    msg_6: "已存在同名的函数或运算符：%1$s",
    msg_7: "应为数字",
    msg_8: "无效数字：%1$s",
    msg_9: "数字必须以一位数字开头",
    msg_10: "应为 %1$s 或 %2$s",
    msg_11: "应为 %1$s",
    msg_12: "应为 %1$s",
    msg_13: "函数名称 %1$s 无效",
    msg_14: "参数数量与期望不符：%1$s",
    msg_15: "仅十进制支持小数",
    msg_16: "计算时出现以下错误：",
    msg_17: "无法转换数字 %1$s 的进制。请将默认进制切换为十进制后重试",
    msg_18: "不支持三次阶乘计算！",
    msg_19: "自定义函数 %1$s 因以下错误无法计算： %2$s",
    msg_20: "函数 %1$s 在非弧度制下无法进行积分运算",
    msg_21: "不支持对 %1$s 进行积分",
    msg_22: "不支持积分",
    msg_23: "在非弧度制下进行复数计算可能得到意外结果！",
    msg_24: "在非弧度制下进行积分计算可能得到意外结果！",
    msg_25: "在非弧度制下进行微分计算可能得到意外结果！",
    osac_msg_5: "未指定函数参数：%1$s",
    osac_msg_6: "表达式中包含无限循环",
};
const UI_MSG_DEFAULT = {
    [0 /* S.app_name */]: "Calculator++",
    [1 /* S.cpp_about */]: "About",
    [2 /* S.cpp_wizard_next */]: "Next",
    [3 /* S.c_first_start_text_1 */]: "Thank you for choosing Calculator++!",
    [4 /* S.c_first_start_text_2 */]: "Calculator++ is a powerful tool for making everyday calculations.",
    [5 /* S.c_wizard_text */]: "<p>Are you looking for an efficient and easy-to-use calculator?<br>Do you want to solve both simple and complex problems?<br>Try Calculator++, a multipurpose calculator app with slick and intuitive user interface!</p><h2>★ Save your time!</h2><ul><li>Access additional features from the main screen of the app using gestures. For example, to use «%» slide button «/» up</li><li>You don't need to press «=» anymore - result is calculated automatically</li><li>Copy with a single button press</li><li>App supports both portrait and landscape screen orientations</li></ul><h2>★ Calculate percentages, square roots, powers, trigonometric functions!</h2><p>Calculator has a big variety of built-in functions</p><h2>★ Use powerful mathematical capabilities of the app:</h2><ul><li>Do calculations with variables and constants</li><li>Use built-in functions</li><li>Integrate and differentiate</li><li>Do calculations with fractions and simplify expressions</li><li>Do calculations with complex numbers</li></ul><h2>★ Open source!</h2><p>This <a href=\"https://github.com/lll69/react-calculatorpp\" target=\"_blank\">project</a> is licensed under <a href=\"https://www.apache.org/licenses/LICENSE-2.0\" target=\"_blank\">Apache License 2.0</a>.</p>",
    [6 /* S.cpp_wizard_finish */]: "Done",
    [7 /* S.cpp_wizard_dragbutton_description */]: "Swipe button provides fast access to the secondary functions",
    [8 /* S.cpp_wizard_dragbutton_action_center */]: "Tap the button below once to use 9",
    [9 /* S.cpp_wizard_dragbutton_action_up */]: "Swipe from the center of the button up to use %",
    [10 /* S.cpp_wizard_dragbutton_action_down */]: "Swipe from the center of the button down to use ^2",
    [11 /* S.cpp_wizard_dragbutton_action_end */]: "Excellent! Tap the button one more time to try again",
    [12 /* S.cpp_angles */]: "Angles",
    [13 /* S.cpp_radix */]: "Radix",
    [14 /* S.cpp_deg */]: "Degrees",
    [15 /* S.cpp_rad */]: "Radians",
    [16 /* S.cpp_grad */]: "Gradians",
    [17 /* S.cpp_turns */]: "Turns",
    [18 /* S.cpp_bin */]: "Binary",
    [19 /* S.cpp_oct */]: "Octal",
    [20 /* S.cpp_dec */]: "Decimal",
    [21 /* S.cpp_hex */]: "Hexadecimal",
    [22 /* S.c_history */]: "History",
    [23 /* S.cpp_vars_and_constants */]: "Variables And Constants",
    [24 /* S.c_var_description_pi */]: "Ratio of any circle\'s circumference to its diameter. Note: this constant is degree unit independent => rad: 3.14, deg: 3.14",
    [25 /* S.c_var_description_e */]: "Unique real number such that the value of the derivative (slope of the tangent line) of the function f(x) = e^x at the point x = 0 is equal to 1",
    [26 /* S.c_var_description_i */]: "Imaginary unit, defined such as i^2 = −1",
    [27 /* S.c_var_description_c */]: "Speed of the light in vacuum, m/s",
    [28 /* S.c_var_description_G */]: "The gravitational constant is an empirical physical constant involved in the calculation of the gravitational attraction between objects with mass, m^3·kg^−1·s^−2",
    [29 /* S.c_var_description_h_reduced */]: "Reduced Planck constant, J·s",
    [30 /* S.c_functions */]: "Functions",
    [31 /* S.c_fun_description_sin */]: "Trigonometric sine function",
    [32 /* S.c_fun_description_cos */]: "Trigonometric cosine function",
    [33 /* S.c_fun_description_tan */]: "Trigonometric tangent function",
    [34 /* S.c_fun_description_cot */]: "Trigonometric cotangent function",
    [35 /* S.c_fun_description_asin */]: "Arcsine - inverse sine function",
    [36 /* S.c_fun_description_acos */]: "Arccosine - inverse cosine function",
    [37 /* S.c_fun_description_atan */]: "Arctangent - inverse tangent function",
    [38 /* S.c_fun_description_acot */]: "Arccotangent - inverse cotangent function",
    [39 /* S.c_fun_description_ln */]: "Natural logarithm - logarithm to base e",
    [40 /* S.c_fun_description_lg */]: "Decadic logarithm - logarithm to base 10",
    [41 /* S.c_fun_description_log */]: "Logarithm - logarithm the specified base",
    [42 /* S.c_fun_description_exp */]: "Exponential function",
    [43 /* S.c_fun_description_sqrt */]: "Square root function",
    [44 /* S.c_fun_description_cubic */]: "Cubic root function",
    [45 /* S.c_fun_description_abs */]: "Gives absolute value of an argument",
    [46 /* S.c_fun_description_sgn */]: "Gives the sign of an argument: -1 if an argument is less than 0, 0 if equals to 0, 1 if more than 0",
    [47 /* S.c_fun_description_eq */]: "Equals function - gives 1 if two arguments are equals, otherwise 0",
    [48 /* S.c_fun_description_le */]: "Lesser-or-equals function - gives 1 if two arguments are equals or the first is less than the second, otherwise 0",
    [49 /* S.c_fun_description_ge */]: "Greater-or-equals function - gives 1 if two arguments are equals or the first is greater than the second, otherwise 0",
    [50 /* S.c_fun_description_ne */]: "Not-equals function - gives 1 if two arguments are not equals, otherwise 0",
    [51 /* S.c_fun_description_lt */]: "Lesser function - gives 1 if the first argument is less than the second, otherwise 0",
    [52 /* S.c_fun_description_gt */]: "Greater function - gives 1 if the first argument is greater than the second, oherwise 0",
    [53 /* S.c_fun_description_rad */]: "Converts degrees into radians: d - degrees, m - minutes (default = 0), s - seconds (default = 0)",
    [54 /* S.c_fun_description_dms */]: "Converts degrees from DMS notation to decimal notation: d - degrees, m - minutes (default = 0), s - seconds (default = 0)",
    [55 /* S.c_fun_description_deg */]: "Converts radians into degrees",
    [56 /* S.c_fun_category_trig */]: "Trigonometric",
    [57 /* S.c_fun_category_hyper_trig */]: "Hyperbolic trigonometric",
    [58 /* S.c_fun_category_comparison */]: "Comparison",
    [59 /* S.c_fun_category_common */]: "Common",
    [60 /* S.c_operators */]: "Operators",
    [61 /* S.derivatives */]: "Derivatives/Integrals",
    [62 /* S.other */]: "Other",
    [63 /* S.c_op_description_mod */]: "Modulo operation finds the remainder of division of \'x\' by \'y\'",
    [64 /* S.c_op_description_sum */]: "Sums functions \'f(i)\', iterating through \'i\' from \'from\' to \'to\'",
    [65 /* S.c_op_description_product */]: "Gives product of functions \'f(i)\', iterating through \'i\' from \'from\' to \'to\'",
    [66 /* S.c_op_description_derivative */]: "Gives derivative of order \'order\' (default = 1) of functions \'f(x)\' by \'x\' variable and calculates at point \'x_point\' (default = same as \'x\')",
    [67 /* S.c_op_description_integral */]: "Gives integral of function \'f(x)\' by \'x\' variable",
    [68 /* S.c_op_description_integral_ab */]: "Integrates function \'f(x)\' by \'x\' variable from \'a\' to \'b\'",
    [69 /* S.c_pf_description_factorial */]: "Gives the factorial of the previous expression",
    [70 /* S.c_pf_description_double_factorial */]: "Gives the double factorial of the previous expression",
    [71 /* S.c_pf_description_percent */]: "Gives the percent value of the expression before.\nExamples:\n100 + 50% = 150\n100 * 50% = 50\n100 + 100 * 50% * 50% = 125",
    [72 /* S.c_pf_description_degree */]: "Converts degrees to radians.\nExamples:\n268° = 4.67748\n30.21° = 0.52726",
    [73 /* S.ok */]: "OK",
    [74 /* S.cancel */]: "Cancel",
};
const UI_MSG_ZH_CN = {
    [0 /* S.app_name */]: "Calculator++",
    [1 /* S.cpp_about */]: "关于",
    [2 /* S.cpp_wizard_next */]: "继续",
    [3 /* S.c_first_start_text_1 */]: "感谢您选择Calculator++！",
    [4 /* S.c_first_start_text_2 */]: "Calculator++ 是处理日常计算的强大工具。",
    [5 /* S.c_wizard_text */]: "<p>您是否在寻找一个高效且易于使用的计算器？<br>需要处理简单到复杂的各类计算问题？<br>试试 Calculator++，这是一款多功能计算器应用，具有流畅直观的用户界面！</p><h2>★ 节省时间！</h2><ul><li>通过手势从应用主屏幕访问附加功能。例如，上滑 / 按钮即可输入 %</li><li>无需再按 = 键：结果会自动计算</li><li>一键实现复制操作</li><li>支持竖屏和横屏显示模式</li></ul><h2>★ 计算百分比、平方根、幂、三角函数！</h2><p>Calculator++ 拥有多种内置函数</p><h2>★ 使用强大的数学功能：</h2><ul><li>使用变量和常量进行计算</li><li>使用内置函数</li><li>积分和求导</li><li>使用分数进行计算并简化表达式</li><li>计算复数</li></ul><h2>★ 开源！</h2><p>本<a href=\"https://github.com/lll69/react-calculatorpp\" target=\"_blank\">项目</a>在 <a href=\"https://www.apache.org/licenses/LICENSE-2.0\" target=\"_blank\">Apache License 2.0</a> 下开源</p>",
    [6 /* S.cpp_wizard_finish */]: "完成",
    [7 /* S.cpp_wizard_dragbutton_description */]: "滑动输入可快速调用次要功能",
    [8 /* S.cpp_wizard_dragbutton_action_center */]: "点击按钮输入 9",
    [9 /* S.cpp_wizard_dragbutton_action_up */]: "向上滑动输入 %",
    [10 /* S.cpp_wizard_dragbutton_action_down */]: "向下滑动输入 ^2",
    [11 /* S.cpp_wizard_dragbutton_action_end */]: "就是这样！点击按钮来重启向导",
    [12 /* S.cpp_angles */]: "角度单位",
    [13 /* S.cpp_radix */]: "进制",
    [14 /* S.cpp_deg */]: "度",
    [15 /* S.cpp_rad */]: "弧度",
    [16 /* S.cpp_grad */]: "百分度",
    [17 /* S.cpp_turns */]: "圆周",
    [18 /* S.cpp_bin */]: "二进制",
    [19 /* S.cpp_oct */]: "八进制",
    [20 /* S.cpp_dec */]: "十进制",
    [21 /* S.cpp_hex */]: "十六进制",
    [22 /* S.c_history */]: "历史记录",
    [23 /* S.cpp_vars_and_constants */]: "变量与常量",
    [24 /* S.c_var_description_pi */]: "圆周长与直径的比值 π。注意：此常数不随角度单位改变 => 弧度: 3.14, 角度: 3.14",
    [25 /* S.c_var_description_e */]: "唯一的实数，使得函数 f(x) = e^x 在 x = 0 处的导数（切线斜率）等于 1。",
    [26 /* S.c_var_description_i */]: "虚数单位，定义为 i²=-1",
    [27 /* S.c_var_description_c */]: "真空中的光速，单位为 m/s",
    [28 /* S.c_var_description_G */]: "万有引力常数是一个经验物理常数，用来计算有质量的物体之间的引力，单位为 m³·kg⁻¹·s⁻²",
    [29 /* S.c_var_description_h_reduced */]: "约化普朗克常数，单位为 J·s",
    [30 /* S.c_functions */]: "函数",
    [31 /* S.c_fun_description_sin */]: "三角正弦函数",
    [32 /* S.c_fun_description_cos */]: "三角余弦函数",
    [33 /* S.c_fun_description_tan */]: "三角正切函数",
    [34 /* S.c_fun_description_cot */]: "三角余切函数",
    [35 /* S.c_fun_description_asin */]: "反正弦函数",
    [36 /* S.c_fun_description_acos */]: "反余弦函数",
    [37 /* S.c_fun_description_atan */]: "反正切函数",
    [38 /* S.c_fun_description_acot */]: "反余切函数",
    [39 /* S.c_fun_description_ln */]: "自然对数 - 以 e 为底的对数",
    [40 /* S.c_fun_description_lg */]: "常用对数 - 以 10 为底的对数",
    [41 /* S.c_fun_description_log */]: "以指定数为底的对数",
    [42 /* S.c_fun_description_exp */]: "指数函数",
    [43 /* S.c_fun_description_sqrt */]: "平方根函数",
    [44 /* S.c_fun_description_cubic */]: "立方根函数",
    [45 /* S.c_fun_description_abs */]: "绝对值函数",
    [46 /* S.c_fun_description_sgn */]: "给出参数符号：如果参数小于 0，则为 -1；如果等于 0，则为 0；如果大于 0，则为 1。",
    [47 /* S.c_fun_description_eq */]: "等于函数 - 如果两个参数相等，返回 1；否则返回 0。",
    [48 /* S.c_fun_description_le */]: "小于等于函数 - 如果参数 1 ≤ 参数 2 则返回 1，否则返回 0。",
    [49 /* S.c_fun_description_ge */]: "大于等于函数 - 如果参数 1 ≥ 参数 2 则返回 1，否则返回 0。",
    [50 /* S.c_fun_description_ne */]: "不等于函数 - 如果两个参数不相等则返回 1，否则返回 0。",
    [51 /* S.c_fun_description_lt */]: "小于函数 - 如果参数 1 < 参数 2 则返回 1，否则返回 0。",
    [52 /* S.c_fun_description_gt */]: "大于函数 - 如果参数 1 > 参数 2 则返回 1，否则返回 0。",
    [53 /* S.c_fun_description_rad */]: "将度转换为弧度：d - 度，m - 分（默认=0），s - 秒（默认=0）",
    [54 /* S.c_fun_description_dms */]: "将度数从度分秒（DMS）表示法转换为十进制表示法：d - 度，m - 分（默认=0），s - 秒（默认=0）",
    [55 /* S.c_fun_description_deg */]: "将弧度转换为度",
    [56 /* S.c_fun_category_trig */]: "三角函数",
    [57 /* S.c_fun_category_hyper_trig */]: "双曲函数",
    [58 /* S.c_fun_category_comparison */]: "比较函数",
    [59 /* S.c_fun_category_common */]: "常用函数",
    [60 /* S.c_operators */]: "运算符",
    [61 /* S.derivatives */]: "导数 / 积分",
    [62 /* S.other */]: "其他",
    [63 /* S.c_op_description_mod */]: "返回 x 除以 y 的余数",
    [64 /* S.c_op_description_sum */]: "对函数 f(i) 求和，i 从 from 到 to",
    [65 /* S.c_op_description_product */]: "对函数 f(i) 求积，i 从 from 到 to",
    [66 /* S.c_op_description_derivative */]: "计算函数 f(x) 对变量 x 的 order 阶导数（order 默认为 1），并在点 x_point（默认为 x）处求值。",
    [67 /* S.c_op_description_integral */]: "计算函数 f(x) 对 x 的积分。",
    [68 /* S.c_op_description_integral_ab */]: "计算函数 f(x) 对 x 从 a 到 b 的定积分。",
    [69 /* S.c_pf_description_factorial */]: "计算表达式的阶乘",
    [70 /* S.c_pf_description_double_factorial */]: "计算表达式的二次阶乘",
    [71 /* S.c_pf_description_percent */]: "计算表达式的百分比。\n例如：\n100 + 50% = 150\n100 * 50% = 50\n100 + 100 * 50% * 50% = 125",
    [72 /* S.c_pf_description_degree */]: "将度转换为弧度。\n例如：\n268° = 4.67748\n30.21° = 0.52726",
    [73 /* S.ok */]: "确定",
    [74 /* S.cancel */]: "取消",
};
const JSCL_LOCALE_MAP = {
    "en-us": JSCL_MSG_DEFAULT,
    "en": JSCL_MSG_DEFAULT,
    "zh-cn": JSCL_MSG_ZH_CN,
    "zh": JSCL_MSG_ZH_CN,
};
const UI_LOCALE_MAP = {
    "en-us": UI_MSG_DEFAULT,
    "en": UI_MSG_DEFAULT,
    "zh-cn": UI_MSG_ZH_CN,
    "zh": UI_MSG_ZH_CN,
};
export const jsclMsgs = Object.assign({}, JSCL_MSG_DEFAULT);
export const msgs = Object.assign({}, UI_MSG_DEFAULT);
const localize = (locale) => {
    const jsclStrings = JSCL_LOCALE_MAP[locale.toLowerCase()];
    if (jsclStrings) {
        Object.assign(jsclMsgs, jsclStrings);
    }
    const uiStrings = UI_LOCALE_MAP[locale.toLowerCase()];
    if (uiStrings) {
        Object.assign(msgs, uiStrings);
    }
};
if (typeof navigator !== "undefined") {
    localize(navigator.language);
    [...navigator.languages].reverse().forEach(localize);
}
